import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import LinkItem from '@/common/interfaces/LinkItem';
import CtaLinkItem, { CtaButtonStyle } from '@/common/interfaces/CtaLinkItem';

import CtaButton from '@/components/CtaButton/CtaButton.vue';

const TagsComponentProps = Vue.extend({
  props: { tags: Array as () => LinkItem[] },
});

@Component({ components: { CtaButton } })
export default class TagsComponent extends TagsComponentProps {
  get TagItems() {
    return this.tags.map((l) => ({ ...l, ButtonStyle: CtaButtonStyle.None } as CtaLinkItem));
  }
}
